var _defs, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowcard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg",
    gradientTransform: "rotate(60)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.6,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0,
    offset: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 252,
    rx: 25,
    x: 6,
    y: 6,
    opacity: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 250,
    rx: 25,
    x: 5,
    y: 5,
    fill: "#ffce00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 240,
    rx: 23,
    x: 10,
    y: 10,
    fill: "url(#lg)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowcard);
export default __webpack_public_path__ + "static/media/yellowcard.d7072d0e25ce7803f31cc8b48aeeaa20.svg";
export { ForwardRef as ReactComponent };